import { Button } from '@hqo/react-components-library/dist/atoms/button';
import styled from 'styled-components';
import { PAYMENT_CONTENT_WIDTH } from 'shared/consts';

export const CancelButton = styled(Button)<{ isSwipeModalContent: boolean }>`
  align-self: flex-end;
  width: 100%;
  height: 48px;
  margin-top: 0;
  padding: 4px 23px;
  border-color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.primary};
  ${({ isSwipeModalContent }) => !isSwipeModalContent && `border: none;`};

  &:hover:not([disabled]) {
    opacity: 0.9;
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ButtonContainer = styled.div`
  width: 215px;

  @media only screen and (max-width: ${PAYMENT_CONTENT_WIDTH}) {
    width: 100%;
  }
`;
